// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminShell_main__tvcog {
  width: 100%;
  display: flex;
}

.AdminShell_body__\\+aPkL {
  flex: 1 1;
  max-width: 100vw;
}
.AdminShell_body__\\+aPkL > * {
  padding: 2rem;
}

.AdminShell_header__UPWCD {
  border-bottom: 1px solid var(--color-grey-2);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.AdminShell_header__a__AjvI0 {
  display: flex;
  align-items: center;
  gap: 1.2rem;
}
.AdminShell_header__a__AjvI0 > :first-child {
  display: none;
}
@media only screen and (max-width: 768px) {
  .AdminShell_header__a__AjvI0 > :first-child {
    display: block;
  }
}
.AdminShell_header__bottom__8E53P {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
}

.AdminShell_ghost__ns34r {
  width: 25rem;
}
@media only screen and (max-width: 768px) {
  .AdminShell_ghost__ns34r {
    display: none;
  }
}

.AdminShell_metric__group__4xwKu {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 1024px) {
  .AdminShell_metric__group__4xwKu {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 480px) {
  .AdminShell_metric__group__4xwKu {
    grid-template-columns: 1fr;
  }
}
.AdminShell_metric__card__CvBKn {
  border: 1px solid var(--color-grey-2);
  padding: 1.6rem;
  border-radius: 1.2rem;
}

.AdminShell_btns__Jwlqx {
  display: flex;
  gap: 1.2rem;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/AdminShell.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,aAAA;AACD;;AAEA;EACC,SAAA;EACA,gBAAA;AACD;AACC;EACC,aAAA;AACF;;AAGA;EACC,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAD;AAGC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;AADF;AAGE;EACC,aAAA;AADH;AAGG;EAHD;IAIE,cAAA;EAAF;AACF;AAIC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAFF;;AAMA;EACC,YAAA;AAHD;AAIC;EAFD;IAGE,aAAA;EADA;AACF;;AAKC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AAFF;AAIE;EALD;IAME,qCAAA;EADD;AACF;AAEE;EARD;IASE,0BAAA;EACD;AACF;AAEC;EACC,qCAAA;EACA,eAAA;EACA,qBAAA;AAAF;;AAIA;EACC,aAAA;EACA,WAAA;EACA,eAAA;AADD","sourcesContent":[".main {\n\twidth: 100%;\n\tdisplay: flex;\n}\n\n.body {\n\tflex: 1;\n\tmax-width: 100vw;\n\n\t& > * {\n\t\tpadding: 2rem;\n\t}\n}\n\n.header {\n\tborder-bottom: 1px solid var(--color-grey-2);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\t// width: 100%;\n\n\t&__a {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 1.2rem;\n\n\t\t& > :first-child {\n\t\t\tdisplay: none;\n\n\t\t\t@media only screen and (max-width: 768px) {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__bottom {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tgap: 2rem;\n\t\tflex-wrap: wrap;\n\t}\n}\n\n.ghost {\n\twidth: 25rem;\n\t@media only screen and (max-width: 768px) {\n\t\tdisplay: none;\n\t}\n}\n\n.metric {\n\t&__group {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: 1024px) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\t\t@media only screen and (max-width: 480px) {\n\t\t\tgrid-template-columns: 1fr;\n\t\t}\n\t}\n\n\t&__card {\n\t\tborder: 1px solid var(--color-grey-2);\n\t\tpadding: 1.6rem;\n\t\tborder-radius: 1.2rem;\n\t}\n}\n\n.btns {\n\tdisplay: flex;\n\tgap: 1.2rem;\n\tflex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `AdminShell_main__tvcog`,
	"body": `AdminShell_body__+aPkL`,
	"header": `AdminShell_header__UPWCD`,
	"header__a": `AdminShell_header__a__AjvI0`,
	"header__bottom": `AdminShell_header__bottom__8E53P`,
	"ghost": `AdminShell_ghost__ns34r`,
	"metric__group": `AdminShell_metric__group__4xwKu`,
	"metric__card": `AdminShell_metric__card__CvBKn`,
	"btns": `AdminShell_btns__Jwlqx`
};
export default ___CSS_LOADER_EXPORT___;
